import { lazy, Suspense, useCallback, useState } from "react";
import './App.css';

import "bootstrap/dist/css/bootstrap.min.css";
import './css/Style.css';
import './css/Responsive.css';


import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Home from "./pages/Home";
import ComingSoon from "./pages/ComingSoon";

import CookieConsentPopup from "./components/CookieConsentPopup";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";


import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"
import ScrollToTop from "./components/ScrollToTop";
import PageLoader from "./components/PageLoader";

const Shop = lazy(() => import("./pages/Shop"));
const Cart = lazy(() => import("./pages/Cart"));
const Checkout = lazy(() => import("./pages/Checkout"));
const Shopdetails = lazy(() => import("./pages/Shopdetails"));
const Wedding = lazy(() => import("./pages/Wedding"));
const Mini = lazy(() => import("./pages/Mini"));
const FAQ = lazy(() => import("./pages/FAQ"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const Signup = lazy(() => import("./pages/Signup"));
const Profile = lazy(() => import("./pages/Profile"));
const OrderSuccess = lazy(() => import("./pages/OrderSuccess"));
const OrderCancelled = lazy(() => import("./pages/OrderCancelled"));
const MyOrders = lazy(() => import("./pages/MyOrders"));
const CustomerNotifications = lazy(() => import("./pages/CustomerNotifications"));
const MyDisputes = lazy(() => import("./pages/MyDisputes"));
const Wishlist = lazy(() => import("./pages/Wishlist"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const CookiePolicy = lazy(() => import("./pages/CookiePolicy"));
const RefundPolicy = lazy(() => import("./pages/RefundPolicy"));
const ShippingPolicy = lazy(() => import("./pages/ShippingPolicy"));

const STORE_LAUNCH_DATE = "2026-10-01T00:00:00+05:30";

function StorefrontApp() {
  const location = useLocation();
  const [hasLaunched, setHasLaunched] = useState(
    () => Date.now() >= new Date(STORE_LAUNCH_DATE).getTime()
  );
  const handleLaunch = useCallback(() => {
    setHasLaunched(true);
  }, []);

  if (!hasLaunched && location.pathname === "/") {
    return (
      <ComingSoon
        launchDate={STORE_LAUNCH_DATE}
        onLaunch={handleLaunch}
      />
    );
  }

  return (
    <>
      <ScrollToTop />
      <AuthProvider allowedRole="customer">
        <Header />
        <Suspense fallback={<PageLoader text="Loading page..." />}>
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/cart" element={
            <ProtectedRoute>
              <Cart />
            </ProtectedRoute>
          } />
          <Route path="/checkout" element={
            <ProtectedRoute>
              <Checkout />
            </ProtectedRoute>
          } />

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/order-success/:order_id"
            element={
              <ProtectedRoute>
                <OrderSuccess />
              </ProtectedRoute>
            }
          />

          <Route
            path="/order-cancelled/:order_id"
            element={
              <ProtectedRoute>
                <OrderCancelled />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <MyOrders />
              </ProtectedRoute>
            }
          />

          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <CustomerNotifications />
              </ProtectedRoute>
            }
          />

          <Route
            path="/wishlist"
            element={
              <ProtectedRoute>
                <Wishlist />
              </ProtectedRoute>
            }
          />

          <Route path="/shop-details/:product_id" element={<Shopdetails />} />
          <Route path="/shop-wedding" element={<Wedding />} />
          <Route path="/srishbish-mini" element={<Mini />} />
          <Route path="/faqs" element={<FAQ />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/login" element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } />
          <Route path="/forgot-password" element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          } />
          <Route path="/reset-password" element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          } />
          <Route path="/signup" element={
            <PublicRoute>
              <Signup />
            </PublicRoute>
          } />

          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />

          <Route
            path="/disputes"
            element={
              <ProtectedRoute>
                <MyDisputes />
              </ProtectedRoute>
            }
          />

          </Routes>
        </Suspense>


        <ToastContainer
          position="top-right"
          autoClose={3000}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />
        <CookieConsentPopup />
        <Footer />
      </AuthProvider>
    </>
  );
}

function App() {
  return (
    <Router>
      <StorefrontApp />
    </Router>
  );
}

export default App;
